<script lang="ts">
  import { Markdown } from '@bruce/components'
  import type { PageData } from './$types'
  import { TERMS_STRINGS } from './strings'

  export let data: PageData
  $: ({ lang, privacy } = data)
</script>

<h1>{TERMS_STRINGS[lang].TITLE}</h1>
<div>
  <Markdown source={privacy} />
</div>

<style lang="scss">
  @use '@bruce/assets/css/breakpoints';

  div {
    max-width: 800px;

    @media screen and (max-width: breakpoints.$breakpoint-md) {
      margin: 0 16px;
    }
  }
</style>
